<template>
  <div v-if="visible && notificacoes.length" class="top-alert-wrapper">
    <b-alert
      v-for="item in notificacoes"
      :key="item.id"
      show
      dismissible
      fade
      variant="warning"
      class="top-alert-box"
      @dismissed="fecharNotificacao(item.id)"
    >
      <div class="alert-text" v-html="formatarTexto(item.notificacao)"></div>
    </b-alert>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'AlertNotificacoes',
  props: {
    show: { type: Boolean, default: false },
  },
  mixins: [utils],
  data() {
    return {
      visible: this.show,
      notificacoes: [],
      loading: false,
    }
  },
  watch: {
    show(val) {
      this.visible = val

      if (val) {
        this.carregarNotificacoes()
      }
    },
    visible(val) {
      this.$emit('update:show', val)
    },
  },
  mounted() {
    if (this.show) {
      this.carregarNotificacoes()
    }
  },
  methods: {
    /**
     * Busca as notificações da API apenas uma vez por sessão
     * e exibe apenas as que ainda não foram mostradas.
     *
     * @returns {Promise<void>}
     */
    async carregarNotificacoes() {
      try {
        /**
         * Verifica se o endpoint já foi chamado nesta sessão.
         */
        const endpointJaChamado = sessionStorage.getItem(
          'atencao_notificacoes_fetched'
        )

        if (endpointJaChamado === 'true') {
          return
        }

        this.loading = true

        const response = await this.$api.get(
          '/app/atencao/' + this.$store.state.cod_ibge + '/notificacoes'
        )

        /**
         * Marca no sessionStorage que o endpoint já foi chamado.
         */
        sessionStorage.setItem('atencao_notificacoes_fetched', 'true')

        /**
         * Mapeia as notificações da API adicionando um ID local.
         */
        const notificacoesApi = (response.data || []).map((item, index) => ({
          ...item,
          id: index + 1,
        }))

        /**
         * Recupera do sessionStorage as notificações
         * já exibidas nesta sessão.
         */
        const notificacoesJaVistas = JSON.parse(
          sessionStorage.getItem('atencao_notificacoes_seen') || '[]'
        )

        /**
         * Filtra apenas notificações ainda não exibidas.
         */
        this.notificacoes = notificacoesApi.filter(
          (item) => !notificacoesJaVistas.includes(item.notificacao)
        )

        /**
         * Salva no sessionStorage as notificações recém exibidas,
         * evitando que apareçam novamente após atualizar a página.
         */
        if (this.notificacoes.length) {
          const novasVistas = [
            ...new Set([
              ...notificacoesJaVistas,
              ...this.notificacoes.map((n) => n.notificacao),
            ]),
          ]

          sessionStorage.setItem(
            'atencao_notificacoes_seen',
            JSON.stringify(novasVistas)
          )
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Fecha uma notificação individual
     *
     * @param {number} id
     * @returns {void}
     */
    fecharNotificacao(id) {
      this.notificacoes = this.notificacoes.filter((item) => item.id !== id)

      if (!this.notificacoes.length) {
        this.visible = false
      }
    },

    /**
     * Formata texto com quebra de linha
     *
     * @param {string} texto
     * @returns {string}
     */
    formatarTexto(texto) {
      // return texto.replace(/\n/g, '<br>')
      return texto
    },
  },
}
</script>

<style scoped>
.top-alert-wrapper {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  width: calc(100% - 32px);
  max-width: 920px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.top-alert-box {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  overflow: hidden;
  margin-bottom: 0;
  padding: 18px 55px 18px 22px;
  border: 0;
  border-left: 6px solid #d99b00;
  border-radius: 14px;
  background: #fff8e6;
  color: #4f3b00;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
}

.alert-text {
  flex: 1;
  margin-right: 12px;
  font-size: 15px;
  line-height: 1.55;
  font-weight: 500;
  white-space: normal;
  text-align: justify;
}

.top-alert-box >>> .close {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  color: #7a5a00;
  opacity: 0.75;
  text-shadow: none;
  font-size: 24px;
  line-height: 1;
}

.top-alert-box >>> .close:hover {
  opacity: 1;
  color: #3d2c00;
}

@media (max-width: 768px) {
  .top-alert-wrapper {
    top: 12px;
    width: calc(100% - 20px);
  }

  .top-alert-box {
    padding: 16px 42px 16px 18px;
    border-radius: 12px;
  }

  .alert-text {
    font-size: 14px;
  }
}
</style>
